export default {
	facebook: 'https://dinova-images-dev.imgix.net/icons/icon-facebook.svg',
	instagram: 'https://dinova-images-dev.imgix.net/icons/icon-instagram.svg',
	pinterest: 'https://dinova-images-dev.imgix.net/icons/icon-pintrest.svg',
	twitter: 'https://dinova-images-dev.imgix.net/icons/icon-twitter.svg',
	youtube: 'https://dinova-images-dev.imgix.net/icons/icon-youtube.svg',
	linkedIn: 'https://dinova-images-dev.imgix.net/icons/icon-linkedin.svg'
};
